import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {PortalService} from '../../../../vna_portal/model/PortalService';
import {VnaCampaignService} from '../../../../vna-campaign/services/vna-campaign.service';
import {AlertaService} from '../../../../../../shared/services/alerta.service';
import {PortalServiceFactoryService} from '../../../../services/portal-service-factory.service';

import * as _ from 'underscore';

@Component({
  selector: 'app-chacon-smssend-parameters',
  templateUrl: './chacon-smssend-parameters.component.html',
  styleUrls: ['./chacon-smssend-parameters.component.scss']
})
export class ChaconSmssendParametersComponent implements OnInit {

    @Input() portalService: PortalService;
    @Input() type: string = 'campaign';

    openCurlyBraces: string = '{{';
    closeCurlyBraces: string = '}}';

    form: FormGroup;
    enabled: boolean = false;
    submitted: boolean = false;

    constructor(private fb: FormBuilder, protected portalServiceFactory: PortalServiceFactoryService, private alertHandler: AlertaService) {
        this.form = this.fb.group({
            content: new FormControl('', [Validators.required, this.textSmsCheck]),
            from: new FormControl('', [Validators.required, Validators.maxLength(11), Validators.minLength(3)]),
            preview_title: new FormControl(),
            preview_image: new FormControl(),
            preview_description: new FormControl(),
            sms_answer_allowed_words: new FormControl()
        });
    }

    ngOnInit() {
        this.form.controls['content'].setValue(this.portalService.getConfigKey('content', ''));
        this.form.controls['from'].setValue(this.portalService.getConfigKey('from', ''));
        this.form.controls['preview_title'].setValue(this.portalService.getConfigKey('preview_title', ''));
        this.form.controls['preview_image'].setValue(this.portalService.getConfigKey('preview_image', ''));
        this.form.controls['preview_description'].setValue(this.portalService.getConfigKey('preview_description', ''));

      if (this.portalService.config.hasOwnProperty('sms_answer_allowed_words')) {
        this.form.controls['sms_answer_allowed_words'].setValue(
          this.portalService.config['sms_answer_allowed_words'].map(
            (value) => {
              return { value: value, display: value}
            }
          )
        );
      }
    }

    save(){
        if(!this.form.valid){
            this.submitted = true;
            return;
        }

        this.enabled=true;
        let criteria = { 'portal_pk' : this.portalService.pkPortal, 'service_pk' : this.portalService.pkService, 'camp_pk' : this.portalService.pkCamp };
        if(this.type == 'action'){
            criteria['action_pk'] = this.portalService['pkAction'];
        }

        const formData = _.clone(this.form.value);
        if ( formData.hasOwnProperty('sms_answer_allowed_words') && _.isArray(formData.sms_answer_allowed_words)) {
          formData.sms_answer_allowed_words = formData.sms_answer_allowed_words.map( (v: any) => {
            return v.value;
          });
        }

        this
            .portalServiceFactory
            .getHandler(this.type)
            .savePortalService(criteria,'sms_sending_parameters', this.portalService.alias, formData)
            .subscribe( result =>{
                this.enabled=false;
                this.alertHandler.addAlert('success','SMS send parameters have been saved successfully')
            })
        ;
    }

    textSmsCheck(control: FormControl) {
      const regex = /\%0a/gi;
      let text: string = control.value.replace(regex, '');
      if (text.length < 3 || text.length > 162) {
        return {
          sms_length: true
        }
      }

      return null;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/chacon-sms/chacon-smssend-parameters/chacon-smssend-parameters.component.ts